module.exports = __webpack_public_path__ + "static/paint-workshop-d4d10e936cd90e64584bc0544e395bea.jpg";